import React, { Component } from 'react';
import styled from 'styled-components'
import cssVar from '../../styles/variables'

import GoogleMap from 'google-map-react';
import config from 'react-global-configuration';
import { SectionText } from './MarketingStyles'
import LeadingBadgeImage from '../../images/icons/leading_badge.png';

class HotelMarker extends Component {

  constructor(props) {
    super(props)
  }

  render() {

    const open = this.props.selected
    const hotel = this.props.hotelData

    return (
      <MarkerWrapper onClick={ () => open ? this.props.deselect() : this.props.select() } open={open}>
        { open &&
          <MarkerPopup>
            <PopupImage src={ `${config.get('DIRECTUS_BACKEND')}assets/${ hotel.image.id }?key=medium` } alt="" />
            <PopupContent>
              <PopupTitle>{ hotel.name }</PopupTitle>
              <PopupText>Hotel</PopupText>
            </PopupContent>
          </MarkerPopup>
        }

        { open &&
          <MarkerIndicator />
        }
        { !open &&
          <MarkerPointerWarper>
            <svg width="100%" height="auto" viewBox="0 0 33 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M31.1838 21.1951C31.2043 21.0961 31.2281 20.9978 31.259 20.9015C31.7532 19.3596 32.02 17.716 32.02 16.01C32.02 7.16792 24.8521 0 16.01 0C7.16792 0 0 7.16792 0 16.01C0 17.6919 0.259353 19.3133 0.740249 20.8362C0.785139 21.0623 0.844969 21.2938 0.920338 21.5307C3.88877 30.86 11.2712 41.762 14.5352 46.3161C15.3182 47.4087 16.9124 47.3792 17.669 46.2681C21.0089 41.3634 28.8074 29.4117 31.1 21.5307C31.1329 21.4178 31.1608 21.306 31.1838 21.1951Z" fill="white"/>
            </svg>
        </MarkerPointerWarper>
        }
        
        <MarkerPoint color="light_grey" />
      </MarkerWrapper>
    )
  }
}

export default HotelMarker

const LeadingBadgeWrapper = styled.div `
  width: 100%;
  background: ${ cssVar.colors.gold };
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 30px;

  img {
    height: 20px;
    width: 100%;
    object-fit: contain;
    object-position: center;
  }
`

const MarkerWrapper = styled.div `
  width: 20px;
  height: 20px;
  position: relative;
  z-index: ${props => props.open ? 101 : 100};
  cursor: pointer;
  transform: translateY(-35px);
`

const MarkerPopup = styled.div `
  background: white;
  position: absolute;
  bottom: calc( 100% );
  left: 10px;
  transform: translateX( -50% );
  width: 200px;
  border-radius: 20px;
  z-index: 101;
  overflow: hidden;
`

const PopupImage = styled.img `
  width: 100%;
  height: 100px;
`

const PopupContent = styled.div `
  padding: 10px;
`

const PopupTitle = styled.div `
  font-family: 'Supreme-Medium';
  font-size: 12px;
  letter-spacing: 0.02em;
  color: black;
  padding-bottom: 5px;
  border-bottom: 1px solid black;
  margin-bottom: 5px;
`

const PopupText = styled.div `
  font-family: 'Supreme-Regular';
  font-size: 12px;
  letter-spacing: 0.03em;
  color: #000000BB;
  padding: 5px 0;
  font-style: italic;
`

const PopupInfoRow = styled.div `
  font-family: 'Supreme-Regular';
  font-size: 12px;
  letter-spacing: 0.03em;
  color: #000000BB;
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
`

const PopupInfoRowTitle = styled.div `
`

const PopupInfoRowData = styled.div `
  font-style: italic;
`

const MarkerPoint = styled.div `
  background: ${ props => ( props.color && cssVar.colors[props.color] ) || cssVar.colors.blue };
  width: 20px;
  height: 20px;
  border-radius: 50%;
  position: absolute;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
`

const MarkerPointerWarper = styled.div `
  position: absolute;
  top: -5px;
  left: -5px;
  width: 30px;
  filter: drop-shadow(0px 5px 20px rgba(47, 67, 97, 0.3));
  transform: matrix(-1, 0, 0, 1, 0, 0);
`

const MarkerIndicator = styled.div `
  background: white;
  position: absolute;
  width: 30px;
  height: 30px;
  border-radius: 0 0 50% 50%;
  top: -5px;
  left: -5px;

  ::before {
    content: '';
    position: absolute;
    left: -5px;
    top: 5px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 5px 5px 0;
    border-color: transparent #ffffff transparent transparent;
  }
  ::after {
    content: '';
    position: absolute;
    right: -5px;
    top: 5px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 5px 0 0;
    border-color: #ffffff transparent transparent transparent;
  }
`



// WEBPACK FOOTER //
// /src/components/marketing/HotelMarker.js